export const mockProducts = [
  {
    id: "PROD-001",
    sku: "SKU-CHAIR-01",
    title: "Ergonomic Office Chair",
    image: "https://images.unsplash.com/photo-1505843490538-5133c6c7d0e1?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse A - Aisle 3",
    description: "Fully adjustable ergonomic office chair with breathable mesh back and lumbar support. Designed for 8+ hours of comfortable seating.",
    price: 299.00,
    stock: 45,
    status: "In Stock"
  },
  {
    id: "PROD-002",
    sku: "SKU-DESK-01",
    title: "Minimalist Standing Desk",
    image: "https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse B - Aisle 1",
    description: "Electric height-adjustable standing desk with a clean white finish and dual motors for smooth transition.",
    price: 450.00,
    stock: 12,
    status: "Low Stock"
  },
  {
    id: "PROD-003",
    sku: "SKU-LAMP-02",
    title: "Architect Desk Lamp",
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse A - Aisle 5",
    description: "Matte black adjustable architect lamp. Provides focused task lighting with a timeless design.",
    price: 85.00,
    stock: 0,
    status: "Out of Stock"
  },
  {
    id: "PROD-004",
    sku: "SKU-ORG-01",
    title: "Desk Organizer Set",
    image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse A - Aisle 2",
    description: "A 3-piece wooden desk organizer set. Includes pen holder, document tray, and small accessories box.",
    price: 45.00,
    stock: 120,
    status: "In Stock"
  },
  {
    id: "PROD-005",
    sku: "SKU-MNT-03",
    title: "Dual Monitor Arm",
    image: "https://images.unsplash.com/photo-1527443154391-420792ce66ba?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse C - Aisle 2",
    description: "Heavy-duty dual monitor arm with gas spring adjustment. Supports screens up to 32 inches.",
    price: 110.00,
    stock: 34,
    status: "In Stock"
  },
  {
    id: "PROD-006",
    sku: "SKU-PLNT-01",
    title: "Faux Potted Monstera",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse A - Aisle 7",
    description: "Lifelike artificial Monstera plant in a simple ceramic white pot. Adds a touch of green without the maintenance.",
    price: 55.00,
    stock: 8,
    status: "Low Stock"
  },
  {
    id: "PROD-007",
    sku: "SKU-MUG-04",
    title: "Ceramic Coffee Mug",
    image: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse B - Aisle 4",
    description: "Handcrafted ceramic mug with a matte finish. Perfect for your morning coffee or tea.",
    price: 24.00,
    stock: 200,
    status: "In Stock"
  },
  {
    id: "PROD-008",
    sku: "SKU-NBK-02",
    title: "Premium Dotted Notebook",
    image: "https://images.unsplash.com/photo-1531346878377-a5be20888e57?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse A - Aisle 1",
    description: "A5 dotted notebook with 120gsm paper and a durable vegan leather cover. Lays perfectly flat.",
    price: 22.00,
    stock: 85,
    status: "In Stock"
  },
  {
    id: "PROD-009",
    sku: "SKU-KEY-01",
    title: "Mechanical Keyboard",
    image: "https://images.unsplash.com/photo-1595225476474-87563907a212?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse C - Aisle 1",
    description: "Minimalist 75% mechanical keyboard with tactile switches and customizable white backlighting.",
    price: 130.00,
    stock: 15,
    status: "Low Stock"
  },
  {
    id: "PROD-010",
    sku: "SKU-MSE-01",
    title: "Wireless Precision Mouse",
    image: "https://images.unsplash.com/photo-1615663245857-ac93bb7c39e7?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse C - Aisle 1",
    description: "Ergonomic wireless mouse with multi-device pairing and a 70-day battery life.",
    price: 80.00,
    stock: 40,
    status: "In Stock"
  },
  {
    id: "PROD-011",
    sku: "SKU-HDPH-01",
    title: "Noise-Cancelling Headphones",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse C - Aisle 3",
    description: "Over-ear wireless headphones with industry-leading active noise cancellation.",
    price: 250.00,
    stock: 22,
    status: "In Stock"
  },
  {
    id: "PROD-012",
    sku: "SKU-CBL-01",
    title: "Cable Management Box",
    image: "https://images.unsplash.com/photo-1555529771-835f59fc5efe?auto=format&fit=crop&w=800&q=80",
    location: "Warehouse B - Aisle 2",
    description: "Sleek bamboo and white plastic box to hide power strips and organize messy cables.",
    price: 28.00,
    stock: 60,
    status: "In Stock"
  }
];